/**
 * Reads the site's content from WordPress.
 *
 * The services, the gallery, and the company details are PHP arrays in the
 * theme's inc/ folder, published by inc/rest-api.php. They are fetched rather
 * than copied into this app so there is one list to edit, not two.
 *
 * In development Vite proxies /wp-json to the DDEV site, and in production the
 * app is served from the same domain as WordPress, so a relative URL is correct
 * in both places.
 */

const BOOTSTRAP_URL = '/wp-json/ttc/v1/bootstrap';

/**
 * Fetches everything the site needs in one request.
 *
 * @param {AbortSignal} [signal] Lets React cancel the request on unmount.
 * @returns {Promise<{company: object, services: object[], gallery: object}>}
 */
export async function fetchContent(signal) {
	// No custom headers on purpose: index.html preloads this URL, and a preload
	// is only reused when the request matches it. The WordPress REST API returns
	// JSON whatever the Accept header says, so a header here would risk a second
	// download and buy nothing.
	const response = await fetch(BOOTSTRAP_URL, { signal });

	if (!response.ok) {
		throw new Error(
			`WordPress returned ${response.status} ${response.statusText} for ${BOOTSTRAP_URL}`
		);
	}

	return response.json();
}

/**
 * The photos marked as featured, used on the home page.
 *
 * @param {object} gallery The gallery payload.
 * @param {number} [limit] How many to return.
 * @returns {object[]}
 */
export function featuredPhotos(gallery, limit = 6) {
	if (!gallery?.photos) {
		return [];
	}

	return gallery.photos.filter((photo) => photo.featured).slice(0, limit);
}
